import React, { useState, useEffect, useRef } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { axios, getAxiosConfig } from '../utils/apiUtils';
import { getLoggedInUser } from '../utils/authUtils';
import styles from './About.module.css';
import logo from '../assets/images/logo_sin_hagamos_cosas_juntos.png';
import logoBottom from '../assets/images/logotipo-chungungo-flor.svg';
import bigImage from '../assets/images/about_big_image.jpg';


import fbLogo from '../assets/images/fb.svg';
import igLogo from '../assets/images/ig.svg';
import unicefLogo from '../assets/images/mini-logo-unicef-blanco.png';

import ximenaFoto from '../assets/images/XIMENA TELLEZ.jpeg';
import javieraFoto from '../assets/images/JAVIERA WARNIER.jpeg';
import lupeFoto from '../assets/images/GUADALUPE RODRIGUEZ.jpeg';
import mariapazFoto from '../assets/images/MARIA PAZ PADILLA.jpeg';
import santiagoFoto from '../assets/images/SANTIAGO MENA.jpeg';
import concepcionFoto from '../assets/images/CONCEPCION QUINTANA.jpeg';
import andresFoto from '../assets/images/ANDRES VALDIVIA.jpeg';
import woodFoto from '../assets/images/Logos Nuestros Amigos/andres_wood_ajuste.jpg';
import anaFoto from '../assets/images/Logos Nuestros Amigos/ana_maria_lyon_ajuste.jpg';
import lauraFoto from '../assets/images/Logos Nuestros Amigos/laura_rama.jpg';
import consueloFoto from '../assets/images/Logos Nuestros Amigos/consuelo_bn.jpg';
import avatarFoto from '../assets/images/Logos Nuestros Amigos/avatar_chungungo.png';

import logoCasaFamilia from '../assets/images/Logos Nuestros Amigos/logo_casa_familia.webp';
import logoCodeduc from '../assets/images/Logos Nuestros Amigos/logo_codeduc.png';
import logoLaFuente from '../assets/images/Logos Nuestros Amigos/logo_la_fuente.png';
import logoOlivo from '../assets/images/Logos Nuestros Amigos/logo_olivo.png';
import logoOncomas from '../assets/images/Logos Nuestros Amigos/logo_oncomas.png';
import logoRenca from '../assets/images/Logos Nuestros Amigos/logo_renca.png';
import logoUnicef from '../assets/images/Logos Nuestros Amigos/logo_unicef_azul_nofondo.png';

import { Stream } from '@cloudflare/stream-react';
import { Redirect } from 'react-router-dom';
import { Button } from 'react-bootstrap';

function debounce(fn, ms) {
  let timer
  return _ => {
    clearTimeout(timer)
    timer = setTimeout(_ => {
      timer = null
      fn.apply(this, arguments)
    }, ms)
  };
}


const About = () => {

  const [isCompressed, setIsCompressed] = useState();
  const [goToSeasons, setGoToSeasons] = useState();
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const video1 = useRef(null);

  useEffect(() => {
    const debouncedHandleScroll = debounce(function handleScroll() {
      if (window.scrollY > 20) {
        setIsCompressed(true);
      } else {
        setIsCompressed(false);
      }
    }, 100);

    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }, 500);

    window.addEventListener('resize', debouncedHandleResize);
    window.addEventListener('scroll', debouncedHandleScroll);

    return _ => {
      window.removeEventListener('resize', debouncedHandleResize);
      window.removeEventListener('scroll', debouncedHandleScroll);
    }
  });

  const registerExpressLoginEvent = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/auth/express_login`,
      {},
      getAxiosConfig(),
    )
      .then(() => console.log('Express login...'))
      .catch(() => console.error('Failed express login event registering!'));
      setGoToSeasons(true);
  }

  if (goToSeasons) {
    return (<Redirect to="/seasons" />);
  }


  return (
    <div className={`${styles.landingHTML} ${styles.bodyAbout}`}>

      <header className={`fixed-top ${styles.navbarChungungo}`}>
        <nav className={`navbar navbar-expand navbar-light bg-light ${styles.navChungungo} ${isCompressed ? styles.navbarCompressed : ''}`} aria-label="Eighth navbar example">
          <div className={`container d-flex flex-column flex-lg-row ${styles.navContainer}`}>
            <a className="navbar-brand" href="/">
              <img style={{width: '100%'}} src={logo} alt="Chungungo" />
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarChungungo"
              aria-controls="navbarChungungo" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse`}>
              <ul className="navbar-nav ml-lg-auto">
                <li className={`nav-item ${styles.loginBtn}`}>
                  {getLoggedInUser() &&
                    <Button variant='invisible' className={`nav-link ${styles.loginButton}`} onClick={() => registerExpressLoginEvent()}>Entrar</Button>
                  }
                  {!getLoggedInUser() &&
                    <a className={`nav-link ${styles.loginButton}`} href="/login">Entrar</a>
                  }
                </li>
                <li className="nav-item">
                  <a className={`nav-link btn btn-primary fw-bold ml-3 ${styles.registerBtn} ${styles.orangeBtn}`} href="/register">Crea tu cuenta</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <section className={`${styles.contenido} container`} >
        <div className="row">
          <div className={`col-12 ${styles.featuredImage}`}>
            <img className="img-fluid" src={bigImage} alt="" />
          </div>
        </div>
        <div className="row">
          <div className="col-11 col-md-9 mx-auto">

            <nav aria-label="breadcrumb"
              style={{
                backgroundColor: 'transparent',
              }}
            >
              <ol className={`${styles.breadcrumb} mb-4`}>
                <li className={`${styles.breadcrumbItem}`}><a href="index.html">Inicio</a></li>
                <li className={`${styles.breadcrumbItem} active`} aria-current="page">Acerca de</li>
              </ol>
            </nav>

            <h2>Acerca de</h2>
            <p>Chungungo es una plataforma educativa de contenidos y actividades para la primera infancia que a través de narrativas, el juego y la creatividad apoyan las interacciones pedagógicas de calidad en los jardines infantiles y su vínculo con las familias.</p>
            <p>Nace como un proyecto de extensión del Jardín Infantil Azulillo, cuyo equipo encabezado por Guadalupe Rodríguez y Santiago Mena, lleva 30 años desarrollando una labor silenciosa pero significativa. Buscan formar niñas y niños conscientes y comprometidos, para que así adquieran valor y respeto por los demás, por la naturaleza que los rodea, por la cultura y por los pueblos originarios del país.</p>
            <p>Niños y niñas creativos, que respeten, valoren y cuiden la naturaleza y su identidad cultural. Que sean libres, creativos, seguros y confiados; ese es el propósito de Chungungo. Llevar un aprendizaje de calidad a todas las niñas y niños del país.</p>
            <p>No queremos niños y niñas pegados a las pantallas, queremos usar las pantallas para colaborar y entregar contenidos para una mejor educación inicial y familias más vinculadas y contentas.</p>

            <div className={`${styles.programs}`}>
              <h3 className="text-center">Nuestros Programas</h3>
              <Splide
                options={{
                  perPage: dimensions.width <= 768 ? 1 : 1,
                  perMove: 1,
                }}
              >
                <SplideSlide className={styles.splideProgram}>
                  <div className={styles.slideContainer}>
                    <h4>Programa Chungungo Educación en Jardines Infantiles</h4>
                    <p>Innovador programa de contenidos, acompañando los procesos de aprendizaje de forma flexible y libre según las necesidades de cada jardín infantil y vinculado a las bases curriculares del Mineduc. Además entrega capacitaciones y programas de apoyo al trabajo en aula, así como una forma simple, atractiva y trazable de vincular la experiencia en el aula con las familias o cuidadores.</p>
                  </div>
                </SplideSlide>

                <SplideSlide className={styles.splideProgram}>
                  <div className={styles.slideContainer}>
                    <h4>Programa Oncomamás + Chungungo en Pacientes Oncológicos </h4>
                    <p>Apoyo para las niñas y niños que por su tratamiento no pueden tener acceso a ningún tipo de educación parvularia. Chungungo los acompaña en las distintas etapas del tratamiento y lugar dónde se encuentre (hospitalizado, quimios ambulatorias y la casa).</p>
                  </div>
                </SplideSlide>

                <SplideSlide className={styles.splideProgram}>
                  <div className={styles.slideContainer}>
                    <h4>Programa Familias: Planes de Suscripción para Familias e Instituciones</h4>
                    <p>Chungungo provee contenidos para una entretención de calidad, creativa y simple.  Promueve la creatividad, fomenta el amor por las historias y lectura desde muy pequeños, y sobre todo, refuerza los vínculos a nivel familiar.</p>
                  </div>
                </SplideSlide>
              </Splide>
            </div>









            <h3 className="text-center">Directorio</h3>
            <div className="row">
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={lupeFoto} alt="Guadalupe Rodríguez" />
                  <h6 className="mt-3">Guadalupe Rodríguez</h6>
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={mariapazFoto} alt="María Paz Padilla" />
                  <h6 className="mt-3">María Paz Padilla</h6>
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={anaFoto} alt="Ana María Lyon" />
                  <h6 className="mt-3">Ana María Lyon</h6>
                </div>
              </div>
            </div>

            <div className="mt-4 row d-flex justify-content-center">
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={woodFoto} alt="Andrés Wood" />
                  <h6 className="mt-3">Andrés Wood</h6>
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={andresFoto} alt="Andrés Valdivia" />
                  <h6 className="mt-3">Andrés Valdivia</h6>
                </div>
              </div>
            </div>

            <h3 className="text-center">Nuestro Equipo</h3>
            <div className="row">

              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={lupeFoto} alt="Guadalupe Rodríguez" />
                  <h6 className="mt-3">Guadalupe Rodríguez</h6>
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={mariapazFoto} alt="María Paz Padilla" />
                  <h6 className="mt-3">María Paz Padilla</h6>
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={santiagoFoto} alt="Santiago Mena" />
                  <h6 className="mt-3">Santiago Mena</h6>
                </div>
              </div>

              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={concepcionFoto} alt="Concepción Quintana" />
                  <h6 className="mt-3">Concepción Quintana</h6>
                </div>
              </div>

              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={javieraFoto} alt="Javiera Warner" />
                  <h6 className="mt-3">Javiera Warner</h6>
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={ximenaFoto} alt="Ximena Téllez" />
                  <h6 className="mt-3">Ximena Téllez</h6>
                </div>
              </div>
              
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={avatarFoto} alt="María José Quintana" />
                  <h6 className="mt-3">María José Quintana</h6>
                </div>
              </div>

              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={lauraFoto} alt="Laura Ramacciotti" />
                  <h6 className="mt-3">Laura Ramacciotti</h6>
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={consueloFoto} alt="Consuelo Moreno" />
                  <h6 className="mt-3">Consuelo Moreno</h6>
                </div>
              </div>
            </div>
            <div className="mt-4 row d-flex justify-content-center">
              <div className="mb-4 mb-lg-0 col-lg-4">
                <div className={`${styles.integrante} text-center`}>
                  <img className="img-fluid" src={avatarFoto} alt="Cristián Valenzuela" />
                  <h6 className="mt-3">Cristián Valenzuela</h6>
                </div>
              </div>
            </div>

            <h3 className="text-center">Nuestros Amigos</h3>
            <div className="row">
              <div className="mb-4 mb-lg-0 col-lg-3 col-md-6">
                <div className={`${styles.logoAmigo} text-center`}>
                  <img className="img-fluid" src={logoUnicef} alt="Unicef" />
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-3 col-md-6">
                <div className={`${styles.logoAmigo} text-center`}>
                  <img className="img-fluid" src={logoOlivo} alt="Fundación Olivo" />
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-3 col-md-6">
                <div className={`${styles.logoAmigo} text-center`}>
                  <img className="img-fluid" src={logoLaFuente} alt="Fundación La Fuente" />
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-3 col-md-6">
                <div className={`${styles.logoAmigo} text-center`}>
                  <img className="img-fluid" src={logoOncomas} alt="Oncomamás" />
                </div>
              </div>
            </div>
            <div className="mt-4 row d-flex justify-content-center">
              <div className="mb-4 mb-lg-0 col-lg-3 col-md-6">
                <div className={`${styles.logoAmigo} text-center`}>
                  <img className="img-fluid" src={logoCasaFamilia} alt="Fundación Casa Familia" />
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-3 col-md-6">
                <div className={`${styles.logoAmigo} text-center`}>
                  <img className="img-fluid" src={logoCodeduc} alt="Codeduc" />
                </div>
              </div>
              <div className="mb-4 mb-lg-0 col-lg-3 col-md-6">
                <div className={`${styles.logoAmigo} text-center`}>
                  <img className="img-fluid" src={logoRenca} alt="Renca" />
                </div>
              </div>
            </div>

            <blockquote className="mb-0">
              Si tienes alguna pregunta o simplemente quieres saber más sobre lo que hacemos en Chungungo, escríbenos <a
                href="mailto:contacto@chungungo.com">contacto@chungungo.com</a>, estaremos felices de conversar contigo.
            </blockquote>
          </div>
        </div>
      </section>

      <footer className={`${styles.footerAbout}`}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <ul className="nav justify-content-center">
                <li className="nav-item">
                  <a className="nav-link" href="/#">Inicio</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/terms_conditions">Términos y Condiciones</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/faq">Preguntas Frecuentes</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://regala.chungungo.com/" target="_blank" rel="noreferrer">¿Quieres regalar Chungungo?</a>
                </li>
              </ul>
              <ul className="nav justify-content-center mb-5">
                <li className="nav-item">
                  <a className="nav-link" href="https://www.facebook.com/somoschungungo" target="_blank" rel="noreferrer"><img src={fbLogo} alt="Facebook" /></a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="https://www.instagram.com/chungungo_com" target="_blank" rel="noreferrer"><img src={igLogo} alt="Instagram" /></a>
                </li>
              </ul>
              <small className="text-muted">Todos los derechos reservados© 2021 Chungungo SPA.</small>
            </div>
          </div>
        </div>
        <div className={`${styles.unicef}`}>
          <img src={unicefLogo} alt="Facebook" />
        </div>
      </footer>

    </div>
  );
}

export default About;